module.exports = __webpack_public_path__ + "static/media/exuberanteNaturalezaPC.63dbc355.png";